import Icon from "@material-ui/icons/AllInbox";
import { capitalize } from "lodash";
import { FC } from "react";
import {
  AutocompleteInput,
  BooleanInput,
  Create,
  CreateProps,
  Edit,
  EditProps,
  ReferenceInput,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
} from "react-admin";
import CrudBreadcrumb from "../../components/CrudBreadcrumb";
import ResourceList from "./list";
import ResourceShow from "./show";

const ResourceEdit: FC<EditProps> = (props) => {
  const IssueEditToolbar: FC<any> = (props) => (
    <Toolbar {...props}>
      <SaveButton disabled={props.pristine} />
    </Toolbar>
  );
  return (
    <>
      <CrudBreadcrumb
        resourceName={Common.resourceName}
        resourceId={props.id}
        mode="edit"
      />
      <Edit {...props} title={`Set Box #${props.id} Edit`}>
        <SimpleForm redirect="show" toolbar={<IssueEditToolbar />}>
          <TextField source="id" />
          <TextInput source="name" label="Set" />
          <ReferenceInput
            source="product_id"
            reference="products"
            filter={{ status: "active" }}
            perPage={50}
            sort={{ field: "name", order: "ASC" }}
          >
            <AutocompleteInput optionText="name" />
          </ReferenceInput>
          {process.env.REACT_APP_COMPANY_CODE === "S&N" && (
            <TextInput source="sap_bin_code" label="SAP Bin Code" />
          )}
          <BooleanInput source="is_one_time_use" label="One Time Use" />
          <BooleanInput source="is_consigned" label="Consignment" />
          <SelectInput
            source="status"
            choices={[
              { id: "active", name: "Active" },
              { id: "inactive", name: "Inactive" },
            ]}
          />
        </SimpleForm>
      </Edit>
    </>
  );
};

const ResourceCreate: FC<CreateProps> = (props) => {
  return (
    <>
      <CrudBreadcrumb
        resourceName={Common.resourceName}
        resourceId={""}
        mode="create"
      />
      <Create {...props} title={"Create Set Box"}>
        <SimpleForm>
          <TextInput source="name" label="Set" />
          <ReferenceInput
            source="product_id"
            reference="products"
            filter={{ status: "active" }}
            perPage={50}
            sort={{ field: "name", order: "ASC" }}
          >
            <AutocompleteInput optionText="name" />
          </ReferenceInput>
          <ReferenceInput
            source="location_id"
            reference="locations"
            filter={{ status: "active", is_virtual: false }}
            perPage={50}
            sort={{ field: "name", order: "ASC" }}
          >
            <AutocompleteInput optionText="name" />
          </ReferenceInput>
          {process.env.REACT_APP_COMPANY_CODE === "S&N" && (
            <TextInput source="sap_bin_code" label="SAP Bin Code" />
          )}
          <BooleanInput source="is_one_time_use" label="One Time Use" />
          <BooleanInput source="is_consigned" label="Consignment" />
        </SimpleForm>
      </Create>
    </>
  );
};

export const Common = {
  useMyHook: () => {
    // This hook is no longer needed since we're using ReferenceInput
    return {};
  },

  resourceName: "product-instances",
  baseBreadCrumb: [
    {
      link: `/product-instances`,
      title: `${capitalize("product-instances")}`,
    },
  ],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: Common.resourceName,
  icon: Icon,
  list: ResourceList,
  show: ResourceShow,
  create: ResourceCreate,
  edit: ResourceEdit,
};
